import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import GuideLayout, { GuideSection } from '../../components/GuideLayout/GuideLayout';
import { P, RowsFrom, StepsFrom, useGuideText } from '../../components/GuideLayout/content';
import { Note } from '../../components/ui';
/** Wochennummer nach ISO 8601 */
function isoWeek(d) {
    const date = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    const day = date.getUTCDay() || 7;
    date.setUTCDate(date.getUTCDate() + 4 - day);
    const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
    return Math.ceil(((date.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
}
function dayOfYear(d) {
    const start = new Date(d.getFullYear(), 0, 0);
    return Math.floor((d.getTime() - start.getTime()) / 86400000);
}
const DAYS = 'MonTueWedThuFriSatSun';
const MONTHS = 'JanFebMarAprMayJunJulAugSepOctNovDec';
/**
 * Gleiche Ersetzung wie in der Uhr (gservices.mc replDate, Codes "dmDMyYwjnop").
 * Wochentag und Monat wie in der englischen Variante der Uhr; je nach Sprache und Schrift
 * zeigt die Uhr die ersten drei Buchstaben des lokalen Namens.
 */
function formatPattern(pattern, d) {
    const pad = (n) => String(n).padStart(2, '0');
    const dow = (d.getDay() + 6) % 7;
    const map = {
        d: () => pad(d.getDate()),
        n: () => String(d.getDate()),
        D: () => DAYS.substring(dow * 3, dow * 3 + 3),
        m: () => pad(d.getMonth() + 1),
        o: () => String(d.getMonth() + 1),
        M: () => MONTHS.substring(d.getMonth() * 3, d.getMonth() * 3 + 3),
        y: () => String(d.getFullYear() - 2000),
        Y: () => String(d.getFullYear()),
        w: () => String(isoWeek(d)),
        j: () => `${d.getFullYear() - 2000}${dayOfYear(d)}`,
        p: () => String(dayOfYear(d)),
    };
    return pattern
        .split('')
        .map((c) => (map[c] ? map[c]() : c))
        .join('');
}
const DateFormatGuidePage = () => {
    const { str } = useGuideText();
    const k = 'g.dateFormat';
    const [pattern, setPattern] = useState('D, d.m.Y');
    const preview = useMemo(() => formatPattern(pattern, new Date()), [pattern]);
    return (_jsxs(GuideLayout, { route: "/guides/date-format", lead: _jsx(P, { k: `${k}.lead` }), children: [_jsxs(GuideSection, { id: "where", title: str(`${k}.where.title`), children: [_jsx(StepsFrom, { k: `${k}.where.steps` }), _jsx(Note, { children: _jsx(P, { k: `${k}.where.dropdown` }) })] }), _jsxs(GuideSection, { id: "codes", title: str(`${k}.codes.title`), children: [_jsx(P, { k: `${k}.codes.intro` }), _jsx(RowsFrom, { k: `${k}.codes.rows`, termAs: "code" })] }), _jsx(GuideSection, { id: "try", title: str(`${k}.preview.title`), children: _jsxs("div", { className: "date-try", children: [_jsx("label", { htmlFor: "date-pattern", className: "ui-eyebrow", children: str(`${k}.preview.label`) }), _jsx("input", { id: "date-pattern", type: "text", value: pattern, maxLength: 24, spellCheck: false, autoComplete: "off", onChange: (e) => setPattern(e.target.value) }), _jsx("span", { className: "ui-eyebrow", children: str(`${k}.preview.result`) }), _jsx("output", { htmlFor: "date-pattern", className: "date-try-result", "aria-live": "polite", children: preview || '—' })] }) }), _jsx(GuideSection, { id: "examples", title: str(`${k}.examples.title`), children: _jsx(RowsFrom, { k: `${k}.examples.rows`, termAs: "code" }) })] }));
};
export default DateFormatGuidePage;
